/* APS brand content: tabs, the brand story arrows, and the video's play button.
   Loaded deferred, only on products that have content. Every part works without it:
   the first tab shows, the cards scroll natively, and the video has its own controls. */
(function () {
  if (window.__apsEbc) return;
  window.__apsEbc = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tabs(root) {
    var list = [].slice.call(root.querySelectorAll('[role=tab]'));
    if (list.length < 2) return;
    var panels = list.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    var cur = 0;
    function show(i, focus) {
      cur = (i + list.length) % list.length;
      list.forEach(function (t, n) {
        var on = n === cur;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[n]) panels[n].hidden = !on;
      });
      if (focus) list[cur].focus();
    }
    list.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1, true); }
      });
    });
    root.querySelectorAll('[data-ebc-step]').forEach(function (b) {
      b.addEventListener('click', function () { show(cur + parseInt(b.getAttribute('data-ebc-step'), 10)); });
    });
    // A phone swipes between panels as well as tapping the arrows or titles. Dylan, 2026-09-11.
    // A mostly sideways move of 40px or more turns the panel; anything more upright is the page
    // scrolling and is left alone. Passive, so it never delays a scroll.
    var area = root.querySelector('.ebc-panels');
    if (area) {
      var x0 = null, y0 = 0;
      area.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      area.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
  }

  function rail(root) {
    var track = root.querySelector('[data-ebc-track]');
    if (!track) return;
    var prev = root.querySelector('[data-ebc-rail-step="-1"]');
    var next = root.querySelector('[data-ebc-rail-step="1"]');
    function step() {
      var c = track.querySelector('.ebc-card');
      return c ? (c.getBoundingClientRect().width + 12) * 2 : 300;
    }
    function ends() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max;
    }
    [prev, next].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        var dir = parseInt(b.getAttribute('data-ebc-rail-step'), 10);
        track.scrollBy({ left: step() * dir, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    track.addEventListener('scroll', ends, { passive: true });
    window.addEventListener('resize', ends, { passive: true });
    ends();
  }

  function video(root) {
    var v = root.querySelector('video');
    var b = root.querySelector('.ebc-play');
    if (!v || !b) return;
    // Starts muted with captions on, decision 10b. The click is the consent to play.
    b.addEventListener('click', function () {
      b.hidden = true;
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () { b.hidden = false; });
    });
    v.addEventListener('play', function () { b.hidden = true; });
  }

  function init() {
    document.querySelectorAll('[data-ebc-tabs]').forEach(tabs);
    document.querySelectorAll('[data-ebc-rail]').forEach(rail);
    document.querySelectorAll('[data-ebc-video]').forEach(video);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
